import { IonGrid, IonRow } from '@ionic/react';

import { convertDate, mergeClassNames } from '@/utils';
import { SessionTypeInDatabase } from '@/utils/getFirebaseSessionTypes';

import { FirebaseTimestamp, Session } from '@/models';

import styles from './SessionSelectionCard.module.css';

import { Tag } from '../Tag/Tag';
import { Card } from './Card';

interface SessionSelectionCardProps {
  sessionType: SessionTypeInDatabase | undefined;
  sessionIndex: number;
  session: Session;
  selected: boolean;
  totalSessions: number;
  handleSessionSelection: (sessionId: string) => void;
}

export const SessionSelectionCard = ({
  sessionType,
  sessionIndex,
  session,
  totalSessions,
  selected,
  handleSessionSelection,
}: SessionSelectionCardProps) => {
  const sessionDate = convertDate(session.date as FirebaseTimestamp);
  const colorForSessionType = () => {
    switch (sessionType?.title.toLowerCase()) {
      case 'gait observations':
        return 'blue';
      case 'knee stability':
        return 'green';
      default:
        return 'yellow';
    }
  };
  return (
    <>
      <Card
        className={selected ? styles.selected : styles.noHorizontalMargin}
        onClick={() => {
          console.log('Session selected:', session.id);
          handleSessionSelection(session.id);
        }}>
        <IonGrid>
          <IonRow className={styles.sessionSectionHeader}>
            <span className={styles.sessionTitle}>{`Session ${totalSessions - sessionIndex}: `}</span>
            <span className={styles.sessionDate}>{sessionDate}</span>
            {sessionType?.title && <Tag variant={colorForSessionType()}>{sessionType.title}</Tag>}
          </IonRow>
        </IonGrid>
      </Card>
    </>
  );
};
